import api from "services/api";
import serveRequestErrors from "common/serve-request-errors";

const getBenefitListing = async (payload) => {
	let response = null;
	let errorMessage = null;

	try {
		const res = await api.get.benefits.option();
		const keyword = (payload?.keyword || "").toLowerCase();
		const content = res.map(({ name, id, ...o }) => ({ label: name, value: id.toString(), ...o })).filter((o) => o.label?.toLowerCase().includes(keyword));
		response = { content };
	} catch (error) {
		errorMessage = serveRequestErrors(error);
	}

	if (response) return response;

	throw errorMessage;
};

export default getBenefitListing;
